import { Trans } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'

import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { useGlobalVariables } from '@/hooks/useGlobalVariables'
import GlobalVariablesDropdown from '@/components/GlobalVariablesDropdown'

export default function ActFormClearGlobalVariable({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { globalVariables } = useGlobalVariables()

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      value: initialData?.value ?? globalVariables[0] ?? '',
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const invalidForm = isEmpty(value) || !!form.errors

  return (
    <div className='w-full max-w-[768px]'>
      <div className='p-4'>
        <p className='text-gray-300 mb-6 leading-relaxed'>
          {/* This screen helps you <strong>remove stored data</strong> from your app. You&apos;ll select an existing Global
          Variable by its <strong>name and scope</strong> (Session or Persistent) from the dropdown, and then save the
          action. This is useful for resetting specific pieces of information when they&apos;re no longer needed in your
          workflow. */}
          <Trans>
            Remove a stored Global Variable by selecting it from the dropdown. This is useful for resetting information
            that&apos;s no longer needed in your app.
          </Trans>
        </p>

        <Field>
          <Label required>Variable to Clear</Label>

          <div className='flex-1'>
            <GlobalVariablesDropdown
              value={value}
              onChange={(value) => {
                form.setValues('value', value)
              }}
            />
            <div className='mt-1 text-m-sm red h-[17px]'>{form.errors?.value}</div>
          </div>
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
